import React from 'react';

import AppFooter from './AppFooter';

const AppFooterContainer = () => <AppFooter />;

export default AppFooterContainer;
